import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import GeneralSettingsContainer from '../generalSettings/generalSettingsContainer';
import LdapSettingsContainer from '../ldap';
import SAMLContainer from '../saml';
import SecuritySettingsContainer from '../security';
import MasterACContainer from '../masterAccessControl';
import Permissions from '../../services/enums/permissions';
import AccessDeniedBehavior from '../../services/enums/accessDeniedBehavior';
import authorize from '../authorization/authorize';
import { inject, observer } from 'mobx-react';


@inject('configurationsStore', 'oidcStore') @observer
export default class SettingsTabRoutes extends Component {

    getGeneralSettingsContainer = () => {
        const AuthorizeGeneralSettingsContainer = authorize(
            [Permissions.manageSystemSettings], AccessDeniedBehavior.displayError)
            (GeneralSettingsContainer);
        return <AuthorizeGeneralSettingsContainer tabId={1} />;
    }

    getLdapSettingsContainer = () => {
        const AuthorizeLdapSettingsContainer = authorize(
            [Permissions.manageAuthenticationProviders], AccessDeniedBehavior.displayError)
            (LdapSettingsContainer);
        return <AuthorizeLdapSettingsContainer tabId={2} />;
    }

    getSamlSettingsContainer = () => {
        const AuthorizeSAMLContainer = authorize(
            [Permissions.manageAuthenticationProviders], AccessDeniedBehavior.displayError)
            (SAMLContainer);
        return <AuthorizeSAMLContainer tabId={3} />;
    }

    getMasterAccessControlContainer = () => {
        const AuthorizeMasterAccessControlContainer = authorize(
            [Permissions.manageAuthenticationProviders], AccessDeniedBehavior.displayError)
            (MasterACContainer);
        return <AuthorizeMasterAccessControlContainer tabId={4} />;
    }

    getSecuritySettingContainer = () => {
        const AuthorizeSecuritySettingsContainer = authorize(
            [Permissions.manageSystemSettings], AccessDeniedBehavior.displayError)
            (SecuritySettingsContainer);
        return <AuthorizeSecuritySettingsContainer tabId={5} />;
    }

    render() {
        const { isMultitenancyMode } = this.props.configurationsStore;

        return (
            <div>
                {<Route path='/settings/general' exact render={() => {
                    return this.getGeneralSettingsContainer();
                }} />}
                {isMultitenancyMode === false && <Route path='/settings/ldap' exact render={() => {
                    return this.getLdapSettingsContainer();
                }} />}
                <Route path='/settings/saml' exact render={() => {
                    return this.getSamlSettingsContainer();
                }} />
                {isMultitenancyMode &&
                    <Route path='/settings/masterAccessControl' exact render={() => this.getMasterAccessControlContainer()} />
                }
                <Route path='/settings/security' exact render={() => { return this.getSecuritySettingContainer(); }} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/settings/settingsTabRoutes.jsx